import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";
import { logger } from "@/lib/logger";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Handles the Emergent Auth return: reads #session_id from the URL fragment,
// exchanges it server-side for our JWT cookie, then lands on the dashboard.
export default function AuthCallback() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        if (!sessionId) throw new Error("Missing session_id");
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        toast.success(`Welcome, ${data.name || data.email}`);
        nav("/dashboard", { replace: true });
      } catch (e) {
        logger.error("Google sign-in failed:", e?.message || e);
        setUser(false);
        toast.error("Google sign-in failed — please try again");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]" data-testid="auth-callback">
      <div className="text-[#8B95A5] font-mono text-sm">Signing you in…</div>
    </div>
  );
}
